<!-- =========================================================================================
  File Name: DataListListView.vue
  Description: Data List - List View
  ------------------------------------------------ ----------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="Course-Main-Tab" class="data-list-container">
    <div slot="no-body" class="tabs-container pb-6">
      <div class="tab-text">
        <vx-card class="mb-6">
          <div class="vx-row">
            <div class="vx-col lg:w-1/3 w-full">
              <p>{{ $t('Trainee') }}</p>
              <vs-input v-model="FeedbackAction.Trainee.FullName" class=" w-full" name="Trainee" disabled="false" />
              <span class="text-danger text-sm" v-show="errors.has('Trainee')">{{ errors.first('Trainee') }}</span>
            </div>
            <div class="vx-col lg:w-1/3 w-full">
              <p>{{ $t('CustomerReview') }}</p>
              <vs-input v-model="FeedbackAction.CustomerReview.Title" class=" w-full" name="CustomerReview"
                disabled="false" />
              <span class="text-danger text-sm" v-show="errors.has('CustomerReview')">{{ errors.first('CustomerReview')
              }}</span>
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col lg:w-1/2 w-full">
              <p>{{ $t('Course') }}</p>
              <vs-input v-model="FeedbackAction.CustomerReview.CourseClass.Course.Name" class=" w-full" name="Course"
                disabled="false" />
              <span class="text-danger text-sm" v-show="errors.has('Course')">{{
                errors.first('Course') }}</span>
            </div>
            <div class="vx-col lg:w-1/2 w-full">
              <p>{{ $t('ClassNo') }}</p>
              <vs-input v-model="FeedbackAction.CustomerReview.CourseClass.ClassNo" class=" w-full" name="ClassNo"
                disabled="false" />
              <span class="text-danger text-sm" v-show="errors.has('ClassNo')">{{ errors.first('ClassNo') }}</span>
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col lg:w-1/2 w-full">
              <p>{{ $t('CustomerReviewQuestion') }}</p>
              <vs-input v-model="FeedbackAction.CustomerReviewQuestion.QuestionText" class=" w-full"
                name="CustomerReviewQuestion" disabled="false" />
              <span class="text-danger text-sm" v-show="errors.has('CustomerReviewQuestion')">{{
                errors.first('CustomerReviewQuestion') }}</span>
            </div>
            <div class="vx-col lg:w-1/2 w-full">
              <p>{{ $t('AnswerText') }}</p>
              <vs-input v-model="FeedbackAction.AnswerText" class=" w-full" name="AnswerText" disabled="false" />
              <span class="text-danger text-sm" v-show="errors.has('AnswerText')">{{ errors.first('AnswerText') }}</span>
            </div>
          </div>
          <div class="vx-row">
            <!-- <vs-checkbox v-model="FeedbackAction.IsTask">{{ $t('IsTask') }} </vs-checkbox> -->
            <div class="mt-5">
              <p>{{ $t('IsTask') }}</p>
              <vs-radio v-model="FeedbackAction.IsTask" class="ml-10 mt-5" vs-value=1 :disabled=iscurrentRule>{{ $t('Yes')
              }}</vs-radio>
              <vs-radio v-model="FeedbackAction.IsTask" class="ml-10 mt-5" vs-value=0 :disabled=iscurrentRule>{{ $t('No')
              }}</vs-radio>
            </div>
          </div>
        </vx-card>

        <vx-card v-if="FeedbackAction.IsTask == 1">
          <div class="vx-row">
            <div class="vx-col lg:w-1/3 w-full">
              <p>{{ $t('Description') }}</p>
              <vs-textarea v-model="TasksProcess.Description" class=" w-full" name="Description"
                :disabled=iscurrentRule></vs-textarea>
              <span class="text-danger text-sm" v-show="errors.has('Description')">{{ errors.first('Description')
              }}</span>
            </div>
            <div class="vx-col lg:w-1/3 w-full">
              <p>{{ $t('Comment') }}</p>
              <vs-textarea v-model="TasksProcess.Comment" class=" w-full" name="Comment" />
              <span class="text-danger text-sm" v-show="errors.has('Comment')">{{ errors.first('Comment')
              }}</span>
            </div>
          </div>
          <div class="vx-col lg:w-1/3 w-full">
            <p class="mt-5" style="font-size: 12px;">{{ $t('AssignTo') }}</p>
            <v-select label="FullName" class="w-full" autocomplete v-model="TasksProcess.UserID" :options="Employees"
              :reduce="ID => ID.Id" :disabled=iscurrentRule />
          </div>
          <div class="vx-col lg:w-1/3 w-full" v-if="TasksProcess.UserID != null">
            <p class="mt-5" style="font-size: 12px;">{{ $t('Status') }}</p>
            <v-select label="Name" class="w-full" autocomplete v-model="TasksProcess.TaskStatusID" :options="StatusList"
              :reduce="ID => ID.ID"></v-select>
          </div>
        </vx-card>

        <div class="vx-row">
          <div class="vx-col w-full">
            <div class="mt-8 flex flex-wrap items-center justify-end">
              <vs-button class="mr-6" @click="submitData">{{ $t('Submit') }}</vs-button>
              <vs-button type="border" color="danger" @click="cancel" :to="{ name: 'FeedbackAction' }">{{ $t('Cancel')
              }}</vs-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import vSelect from 'vue-select'
import moduleAssessmentResult from "@/store/customerReview/assessmentResult/moduleAssessmentResult.js";
import { domain, mainSetting } from '@/gloabelConstant.js';

export default {
  components: {
    vSelect,
  },
  data() {
    return {
      isMounted: false,
      baseURL: domain,
      UploadRequestHeader: mainSetting.UploadRequestHeader,
      FeedbackAction: {},
      TasksProcess: {},
      Employees: [],
      StatusList: [],
      CustomerID: "",
      currentRule: "",
    };
  },
  computed: {
    iscurrentRule() {
      debugger
      if (this.currentRule != "admin") {
        debugger
        return true;
      }
    }
  },

  methods: {
    cancel() {
      this.$router.push('/FeedbackAction/FeedbackAction');
      this.FeedbackAction = {};
    },

    submitData() {
      debugger
      if (this.FeedbackAction.IsTask == 1) {
        this.FeedbackAction.IsTask = true;
        this.FeedbackAction.TaskStatusID = this.TasksProcess.TaskStatusID;
      } else if (this.FeedbackAction.IsTask == 0) {
        this.FeedbackAction.IsTask = false;
      }
      debugger;
      this.$store.dispatch("AssessmentResultList/updateItem", this.FeedbackAction).then(() => {
        this.$vs.loading.close();
        this.cancel();
      }).catch(err => {
        this.$vs.loading.close();
        console.error(err);
      });
      this.TasksProcess.AssessmentResultID = this.$route.params.ID;
      if (this.FeedbackAction.IsTask == 1) {
        this.$store.dispatch("AssessmentResultList/addTask", this.TasksProcess).then(() => {
          this.$vs.loading.close();
          this.cancel();
        }).catch(err => {
          this.$vs.loading.close();
          console.error(err);
        });
      }
      else {
        this.$store.dispatch("AssessmentResultList/removeTask", this.TasksProcess).then(() => {
          this.$vs.loading.close();
          this.cancel();
        }).catch(err => {
          this.$vs.loading.close();
          console.error(err);
        });
      }
    },
  },

  created() {
    if (!moduleAssessmentResult.isRegistered) {
      this.$store.registerModule("AssessmentResultList", moduleAssessmentResult);
      moduleAssessmentResult.isRegistered = true;
    }
    const ID = this.$route.params.ID;
    debugger
    if (ID != undefined) {
      this.$store.dispatch("AssessmentResultList/GetFeedBackDetailsByID", ID)
        .then(res => {
          debugger
          this.FeedbackAction = res.data;
          debugger
          if (this.FeedbackAction.IsTask == 1) {
            this.$store.dispatch("AssessmentResultList/GetTask", ID)
              .then(res => {
                this.TasksProcess = res.data;
              })
              .catch(err => {
                console.error(err)
              })
          }
        })
        .catch(err => {
          console.error(err)
        })
    }
    this.$store.dispatch("AssessmentResultList/GetEmployee")
      .then(res => {
        this.Employees = res.data;
        debugger
      })
      .catch(err => {
        console.error(err)
      })

    this.$store.dispatch("AssessmentResultList/GetTaskStatus")
      .then(res => {
        this.StatusList = res.data;
        debugger
      })
      .catch(err => {
        console.error(err)
      })

    this.currentRule = JSON.parse(localStorage.getItem("userInfo")).userRole;


  },
  mounted() {
    this.isMounted = true;
  }
};
</script>

<style lang="scss">
#data-list-list-view {
  .vs-con-table {
    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;

      >span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);

        td {
          padding: 20px;

          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }

          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }

        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }

      th.td-check {
        padding: 0 15px !important;
      }

      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}

input[type="color" i] {
  height: 35px !important;
}

#colorPicer .vs-input--input.normal {
  padding: 0.2rem
}
</style>
